export const nameAccess = {
    ADMIN: 'admin',
    DASHBOARD: 'dashboard',
    FORM: 'form'
};